import navigationConfig from 'app/fuse-configs/navigationConfig';
import * as Actions from '../../actions/fuse';

const INITIAL_STATE = navigationConfig;

const navigation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Actions.GET_NAVIGATION: {
      return state;
    }
    case Actions.SET_NAVIGATION: {
      return [...action.navigation];
    }
    case Actions.RESET_NAVIGATION: {
      return [...navigationConfig];
    }
    default: {
      return state;
    }
  }
};

export default navigation;
